import { Injectable, inject } from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { firstValueFrom } from 'rxjs';
import { changeCoverAsset } from '../lib/change-cover-asset';
import { AccessLevelService } from './access-level.service';
import { AssetService } from './asset.service';
import { GalleryService } from './gallery.service';
import { SectionService } from './section.service';
import { UpdateService } from './update.service';
import { UploadService } from './upload.service';

@Injectable({
  providedIn: 'root',
})
export class GalleryMetaImageUploadService {
  private sectionService = inject(SectionService);
  private uploadService = inject(UploadService);
  private galleryService = inject(GalleryService);
  private assetService = inject(AssetService);
  private updateService = inject(UpdateService);
  private accessLevelService = inject(AccessLevelService);

  async upload(file: File, gallery: GalleryDto, type: 'teaser' | 'cover') {
    const shouldUnsubscribe = this.updateService.subscribeGallery(gallery.id);
    const section = await firstValueFrom(this.sectionService.createSection(gallery.id, 'asset', 612512));
    const _asset = await this.uploadService.uploadSingle(file, gallery, section.id);
    if (!_asset) return;
    const [asset, isGalleryGuest] = await Promise.all([
      this.uploadService.waitForAssetProcessing(_asset.id),
      firstValueFrom(this.accessLevelService.isGalleryGuest(gallery)),
    ]);
    if (!this.assetService.canDisplayAsset(asset)) {
      await this.assetService.deleteAsset(asset, isGalleryGuest);
      return;
    }
    changeCoverAsset(gallery[type], asset);
    const resp = await this.galleryService.updateGallery(gallery.id, { [type]: gallery[type] });
    await firstValueFrom(this.sectionService.deleteSection(section));
    if (shouldUnsubscribe) this.updateService.unsubscribeGallery(gallery.id);
    return resp;
  }
}
